import {
    InfoMailtipAutomaticReply,
    ShowMoreInfobarDetails,
    ShowLessInfobarDetails,
} from './SingleRecipientAutomaticReplyDetails.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
import * as React from 'react';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getInfoBarLinkColorStyle from 'owa-info-bar/lib/utils/getInfoBarLinkColorStyle';
import getOOFMessage from '../utils/getOOFMessage';
import { InfobarShowHideDetailsPart } from 'owa-info-bar-view';
import RecipientMailtipMessageRow from './RecipientMailtipMessageRow';
import shouldTruncateOOFMessage from '../utils/shouldTruncateOOFMessage';
import {
    MailTipsActionType,
    MailTipsType,
    MailTipsCategory,
    MailtipsActionDatapointName,
} from '../datapoints';
import { logUsage } from 'owa-analytics-actions';

const classNames = require('classnames');
const styles = require('./MultiRecipientMailtip.scss');

export interface RecipientMailtipInfo {
    recipient: EmailAddressWrapper;
    automaticReply: string;
}

export interface SingleRecipientAutomaticReplyDetailsProps {
    recipientInfo: RecipientMailtipInfo;
    removeRecipientActionElement: JSX.Element;
    colorScheme?: ColorScheme;
}

export interface SingleRecipientAutomaticReplyDetailsState {
    isDetailShown: boolean;
}

@observer
export default class SingleRecipientAutomaticReplyDetails extends React.Component<
    SingleRecipientAutomaticReplyDetailsProps,
    SingleRecipientAutomaticReplyDetailsState
> {
    constructor(props: SingleRecipientAutomaticReplyDetailsProps) {
        super(props);
        this.state = {
            isDetailShown: false,
        };
    }

    private toggleIsDetailShown = () => {
        this.setState({
            isDetailShown: !this.state.isDetailShown,
        });
        // Log datapoint
        const actionType = !this.state.isDetailShown
            ? MailTipsActionType.ShowLess
            : MailTipsActionType.ShowMore;
        logUsage(MailtipsActionDatapointName, [
            actionType,
            MailTipsCategory.OutOfOffice,
            MailTipsType.SingleRecipient,
            1,
        ]);
    };

    render() {
        const { recipientInfo, colorScheme } = this.props;
        const shouldShowHideDetailsPartBeShown: boolean = shouldTruncateOOFMessage(
            recipientInfo.automaticReply
        );
        const recipientMessage: JSX.Element = getOOFMessage(
            recipientInfo.automaticReply,
            shouldShowHideDetailsPartBeShown && !this.state.isDetailShown
        );

        const linkStyle = classNames(styles.link, getInfoBarLinkColorStyle(colorScheme));

        return (
            <div>
                <span className={styles.blankSpaceAfter}>
                    <RecipientMailtipMessageRow
                        recipient={recipientInfo.recipient}
                        recipientMessage={recipientMessage}
                        messageTemplate={loc(InfoMailtipAutomaticReply)}
                    />
                </span>
                {shouldShowHideDetailsPartBeShown && (
                    <>
                        <InfobarShowHideDetailsPart
                            showDetailsText={loc(ShowMoreInfobarDetails)}
                            hideDetailsText={loc(ShowLessInfobarDetails)}
                            detailsElement={null}
                            clickHandler={this.toggleIsDetailShown}
                            isShowingDetails={this.state.isDetailShown}
                            className={linkStyle}
                        />
                        <span> | </span>
                    </>
                )}
                {this.props.removeRecipientActionElement}
            </div>
        );
    }
}
